export type GeneralMock = {
    preloaderMinDurationMs: number;
};

export const generalMock: GeneralMock = {
    preloaderMinDurationMs: 1200,
};
